import { TableCell, TableHead, TableRow } from "@mui/material";
import React from "react";

const headerCellStyle = {
  fontSize: "13px",
  // fontWeight: 600,
  borderLeft: "1px solid #ddd",
  whiteSpace: "nowrap",
  py: 1,
  // textAlign: "center",
  backgroundColor: "#ececec",
  textWrap:"wrap",
//   width:"25%"
};


function MetricesTableHeader({ tableData, page }) {
  return (
    <>
      <TableHead sx={{ height: "70px", boxSizing: "border-box" }}>
        <TableRow>
          {tableData.columns.map((column, index) => (
            <TableCell
              key={index}
              sx={{
                ...headerCellStyle,
                borderTopLeftRadius: index === 0 ? "20px" : "0px",
                borderTopRightRadius:
                  index === 1 ? "20px" : "0px",
                width: index === 1 ? "80%" : (index === 2 ? "20%" : "10%"),
              }}
            >
              {column}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    </>
  );
}

export default MetricesTableHeader;
